import React from 'react'
import {
  ContainerPricingModel,
  Product,
} from '../../../../modules/productsListing/types'
import { FormikProps, useFormikContext } from 'formik'
import {
  EntitlementOption,
  FieldMetadata,
  FieldMetadataField,
  PrivateOffer,
} from '../../../../modules/privateOffer/types'
import {
  BoxV4,
  RadioButtonGroupMapping,
  RadioButtonType,
  RadioButtonsV2,
} from '@labrav/react-components'
import { Typography } from '@mui/material'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShelves } from '@fortawesome/pro-regular-svg-icons'
import { useStyles } from './PrivateOfferProductDimensions.styels'
import { StandardDimensionsV2 } from '../../../../common/components/StandardDimensionsV2/StandardDimensionsV2'
import { useSelector } from '../../../../store'

export type PrivateOfferProductDimensionsProps = {
  product: Product
}
export const PrivateOfferProductDimensions: React.FC<
  PrivateOfferProductDimensionsProps
> = ({ product }) => {
  const { values, setFieldValue } =
    useFormikContext() as FormikProps<PrivateOffer>
  const formikProps = useFormikContext() as FormikProps<PrivateOffer>
  const { classes } = useStyles()
  const dimensionSelectionMapping: RadioButtonGroupMapping[] = [
    {
      key: EntitlementOption.SINGLE,
      label: 'Buyer can choose only one of the existing dimensions',
      type: RadioButtonType.STANDARD,
    },
    {
      key: EntitlementOption.MANY,
      label: 'Buyer can choose one or more existing dimensions',
      type: RadioButtonType.STANDARD,
    },
  ]
  const handleSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as string
    setFieldValue('entitlementOption', value)
  }
  const fieldMetadata = useSelector<FieldMetadata | undefined>(
    state =>
      state.privateOffersInCreation.currentPrivateOfferInCreation[
        product.productId
      ]?.fieldMetadata
  )

  const isEntitlementOptionReadOnly = (
    fieldMetadata?.entitlementOption as FieldMetadataField
  )?.readOnly
  const isEntitlementOptionHidden = (
    fieldMetadata?.entitlementOption as FieldMetadataField
  )?.hidden
  return (
    <div data-testid="productDimensions-section">
      <BoxV4
        heading={'Product dimensions'}
        headingIcon={
          <FontAwesomeIcon
            icon={faShelves}
            style={{ width: '18px', height: '14px' }}
          />
        }
      >
        {/* entitlements option */}
        {!values.flexiblePaymentTerms &&
          product.containerPricingModel === ContainerPricingModel.CONTRACT &&
          !isEntitlementOptionHidden && (
            <div
              className={classes.sectionContainer}
              data-testid="entitlement-options"
            >
              <Typography className={classes.sectionHeading}>
                Choose the entitlement type you want to offer
              </Typography>
              <div className={classes.radioButton}>
                <RadioButtonsV2
                  checkedValue={{
                    key: values?.entitlementOption as string,
                    value: values?.entitlementOption as string,
                  }}
                  name="entitlementOption"
                  radioButtonMappings={dimensionSelectionMapping.map(
                    option => ({
                      ...option,
                      disabled: isEntitlementOptionReadOnly,
                    })
                  )}
                  handleChange={handleSelection}
                />
              </div>
            </div>
          )}
        {/* product dimenions */}
        <div className={classes.sectionContainer}>
          <div className={classes.textContainer}>
            <Typography className={classes.sectionHeading}>
              Product dimensions
            </Typography>
            <Typography className={classes.sectionText}>
              {`Customize the ${
                values.flexiblePaymentTerms ? 'units' : 'prices'
              } for your listing.`}
            </Typography>
          </div>
          <StandardDimensionsV2
            product={product}
            formik={
              formikProps as unknown as FormikProps<Record<string, unknown>>
            }
            addButtonName={'Add more dimensions'}
            productId={product?.productId}
            isFlexible={values?.flexiblePaymentTerms}
          />
        </div>
      </BoxV4>
    </div>
  )
}
